// extracted by mini-css-extract-plugin
export default {"popover-root":"WmZAIu","popoverRoot":"WmZAIu"};